import FavoriteList from "./container"
export default FavoriteList;